<template>
  <div class="litigant">
    <Row class="detail-header">
      <span>证据</span>
      <Row v-if="caseDetail.state == 'HH' && allowEdit" class="add-btn">
        <Button type="primary" @click="openAdd">取证</Button>
      </Row>
    </Row>
    <Row class="table-box" style="margin-bottom:16px;">
      <Table
        :columns="columns" :loading="tableLoading"
        :data="evidenceData"
      >
        <template slot="action" slot-scope="{ row, index }">
          <Icon
            v-if="caseDetail.state != 'HH' || !row.status"
            type="md-eye"
            size="14"
            style="cursor:pointer"
            @click="option(row, 'info')"
          />
          <Dropdown
            v-else transfer
            @on-click="option(row, $event)"
          >
            <a href="javascript:void(0)">
              <Icon type="ios-more" size="20" />
            </a>
            <DropdownMenu slot="list">
              <DropdownItem name="info">查看详情</DropdownItem>

              <DropdownItem v-if="allowEdit" name="edit">修改</DropdownItem>
              <DropdownItem v-if="allowEdit" name="delete">删除</DropdownItem>
              <!-- 法信  v-if="row.evidOrderId !== '' && row.confirmStatus == 'P' || row.confirmStatus == 'E'"-->
              <DropdownItem
                v-if="row.confirmStatus == 'E'" name="inValid"
              >标记无效</DropdownItem>
              <DropdownItem
                v-if="row.evidOrderId !== null"
                name="recertification"
              >重新取证</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </template>
      </Table>
    </Row>
    <Row class="detail-header"> <span>关联证据</span> </Row>
    <Row class="table-box">
      <Table
        :columns="columns"
        :loading="tableLoading"
        :data="relatedEvidenceData"
      >
        <template slot="action" slot-scope="{ row, index }">
          <Icon
            v-if="caseDetail.state != 'HH'"
            type="md-eye"
            size="14"
            style="cursor:pointer"
            @click="option(row, 'info')"
          />
        </template>
      </Table>
    </Row>

    <!-- 删除modal -->
    <Modal
      v-model="optionCtrl"
      title="删除确认"
      :width="360"
      :footer-hide="true"
    >
      <Row class="modal-tips">请问是否删除此证据？</Row>
      <Row style="text-align:center;margin:10px 0px 14px;">
        <Button
          type="primary"
          :disabled="isSubmit"
          :loading="isSubmit"
          @click="optionConfrim"
        >确认</Button>
        <Button
          style="margin-left: 8px" @click="optionCtrl = false"
        >取消</Button>
      </Row>
    </Modal>

    <!-- 详情抽屉 -->
    <Modal
      v-model="infoDrawerCtrl"
      :title="title"
      width="600"
      :footer-hide="true"
    >
      <Row :style="blockStyle">
        <Row v-if="isInfo && infoDrawerCtrl">
          <case-evidence-info
            :default-data="detailData"
            :clue-detail="clueDetail"
          />
        </Row>
        <Row v-if="!isInfo && infoDrawerCtrl" class="detail-form">
          <case-evidence-form
            :default-data="detailData"
            :clue-detail="clueDetail"
            @changeEditCtrl="changeCtrl"
          />
        </Row>
      </Row>
    </Modal>

    <!-- 无效modal -->
    <Modal
      v-model="confirmStatusStr"
      title="无效原因"
      :width="360"
      :footer-hide="true"
    >
      <Form
        ref="formData" :model="formData"
        :label-width="80"
      >
        <FormItem
          label="无效原因"
          prop="invalidReason"
          :rules="[
            { required: true, message: '请选择不能为空', trigger: 'blur' }
          ]"
        >
          <Select v-model="formData.invalidReason" placeholder="请选择无效原因">
            <Option
              v-for="item in evidInvalidList"
              :key="item.id"
              :value="item.label"
            >{{ item.nameZh }}</Option>
          </Select>
        </FormItem>
      </Form>
      <Row style="text-align:center;margin:10px 0px 14px;">
        <Button
          type="primary" :disabled="isSubmit"
          @click="confirmSubmit"
        >确认</Button>
        <Button
          style="margin-left: 8px" @click="confirmStatusStr = false"
        >取消</Button>
      </Row>
    </Modal>
    <!-- 重新取证 -->
    <Modal
      v-model="afreshCtrl"
      title="重新取证"
      :width="450"
      :footer-hide="true"
    >
      <Form
        ref="formWebUrlData" :model="formWebUrlData"
        :label-width="80"
      >
        <FormItem
          label="链接地址"
          prop="webUrl"
          :rules="[
            { required: true, message: '链接地址不能为空', trigger: 'blur' }
          ]"
        >
          <Input
            v-model.trim="formWebUrlData.webUrl"
            placeholder="请输入链接地址"
          />
        </FormItem>
      </Form>
      <Row style="text-align:center;margin:15px 0 10px;">
        <Button
          type="primary" :disabled="isSubmit"
          @click="afreshSubmit"
        >确定</Button>
        <Button
          style="margin-left: 8px" @click="afreshCtrl = false"
        >取消</Button>
      </Row>
    </Modal>

    <preview-file ref="perviewFile" :read-only="true" />
  </div>
</template>
<script>
import styles from '@/assets/globalStyle.scss'
import caseEvidenceInfo from './caseEvidenceInfo.vue'
import caseEvidenceForm from './caseEvidenceForm.vue'
export default {
  components: {
    caseEvidenceForm,
    caseEvidenceInfo
  },
  props: ['caseDetail', 'clueDetail', 'allowEdit', 'snapShot'],
  data() {
    return {
      confirmStatusStr: false,
      afreshCtrl: false,
      confirmCtrl: false,
      evidInvalidList: [],
      formData: {
        invalidReason: ''
      },
      formWebUrlData: {
        webUrl: ''
      },
      styles: styles,
      blockStyle: {
        'max-height': '',
        'overflow-y': 'auto',
        margin: '-16px',
        padding: '16px'
      },
      activeObj: {},
      optionCtrl: false,
      tableLoading: false,
      isSubmit: false,
      infoDrawerCtrl: false,
      isInfo: false,
      title: '',
      columns: [
        {
          title: '证据类型',
          key: 'evidTypeName'
        },
        {
          title: '公证书号/证据编号',
          key: 'notarialCode'
        },
        {
          title: '取证时间',
          key: 'evidDate',
          render: (h, params) => {
            return h('span', this.common.formatTime(params.row.evidDate, 1))
          }
        },
        {
          title: '落款/固证时间',
          key: 'notarialObtainDate',
          render: (h, params) => {
            const str =
              params.row.evidType == 'EC'
                ? params.row.curingTime
                : params.row.notarialObtainDate
            return h('span', this.common.formatTime(str, 1))
          }
        },
        {
          title: '公证费',
          key: 'notarialFees',
          render: (h, params) => {
            return h(
              'span',
              this.common.formateNumber(params.row.notarialFees || '')
            )
          }
        },
        //   法信才会出现---取证截图

        {
          title: '公证书附件',
          key: 'notarialDeedAttachments',
          render: (h, params) => {
            // const dom = h(
            //   'a',
            //   {
            //     class: {
            //       textover: true
            //     },
            //     attrs: {
            //       title:
            //         params.row.notarialDeedAttachments.length > 0
            //           ? params.row.notarialDeedAttachments[0].fileName
            //           : ''
            //     },
            //     on: {
            //       click: () => {
            //         this.download(params.row.notarialDeedAttachments)
            //       }
            //     }
            //   },
            //   params.row.notarialDeedAttachments.length > 0
            //     ? params.row.notarialDeedAttachments[0].fileName
            //     : ''
            // )
            // return dom
            if (params.row.notarialDeedAttachments.length == 0) {
              return h('span', '')
            }
            const spanDom = h(
              'span',
              {
                class: ['textover'],
                style: {
                  cursor: 'pointer',
                  color: styles.globalMainColor
                },
                on: {
                  click: () => {
                    this.handleLinkView(
                      params.row.notarialDeedAttachments &&
                        params.row.notarialDeedAttachments[0]
                    )
                  }
                }
              },
              params.row.notarialDeedAttachments[0].fileName
            )
            return spanDom
          }
        },
        {
          title: '是否有效',
          key: 'confirmStatusName'
        },

        {
          title: '操作',
          slot: 'action',
          width: 80
        }
      ],
      tableData: [],
      detailData: {},

      ids: []
    }
  },
  computed: {
    relatedEvidenceData() {
      if (!this.tableData || this.tableData.length == 0) {
        return []
      }
      return this.tableData.filter((item, index) => {
        return item.caseId != this.caseDetail.id
      })
    },
    evidenceData() {
      if (!this.tableData || this.tableData.length == 0) {
        return []
      }
      return this.tableData.filter((item, index) => {
        return item.caseId == this.caseDetail.id
      })
    }
  },
  watch: {},
  created() {},
  beforeMount() {
    this.blockStyle['max-height'] = document.body.clientHeight * 0.8 - 55 + 'px'
    this.detailData.caseId = this.caseDetail.id
    this.getDictionary()
  },
  mounted() {
    this.getData()
  },
  updated() {},
  methods: {
    // 打开链接
    handleLinkView(item) {
      const arr = ['image', 'sheet', 'ms-excel', 'xlsx', 'xls', 'document', 'msword', 'docx', 'doc', 'powerpoint', 'presentation', 'pdf', 'text/plain', 'txt']
      if (arr.some(value => item.mediaType.includes(value))) {
        // arr里面 是在线预览，其他都打开新窗口
        this.$refs.perviewFile.preview(item)
      } else {
        const url = item.url
        window.open(url, '_blank')
        return
      }
    },
    download(data) {
      const url = data[0].url
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.target = '_blank'
      link.setAttribute('download', data[0].fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    getData() {
      let url = ''
      if (this.snapShot) {
        url = '/business/evidences/snapshot'
      } else {
        url = '/business/evidences'
      }
      console.log(url)
      // const url = '/business/evidences'
      const ajaxData = { caseId: this.caseDetail.id }
      this.tableLoading = true
      this.$get(url, ajaxData).then(res => {
        this.tableLoading = false
        if (res.code == 0) {
          this.tableLoading = false
          this.tableData = res.data
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    getDetail() {
      let url = ''
      if (this.snapShot) {
        url = '/business/evidences/snapshot' + this.activeObj.id
      } else {
        url = '/business/evidence/' + this.activeObj.id
      }
      this.$get(url).then(res => {
        if (res.code == 0) {
          this.detailData = res.data
          this.infoDrawerCtrl = true
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    option(row, name) {
      this.activeObj = row
      this.invalidId = row.id
      switch (name) {
        case 'info':
          this.isInfo = true
          this.title = '取证详情'
          this.getDetail()
          break
        case 'edit':
          this.isInfo = false
          this.title = '修改取据'
          this.getDetail()
          break
        case 'delete':
          if (
            this.evidenceData.length <= 1 &&
            row.caseId == this.caseDetail.id
          ) {
            this.$Message.error('至少保留一条证据')
            return
          }
          this.optionCtrl = true
          break
        case 'inValid': // 标记无效
          this.confirmStatusStr = true
          break
        case 'recertification': // 重新取证
          this.afreshCtrl = true
          break
      }
      this.acceptCtrl = true
    },
    openAdd() {
      this.detailData = {
        caseId: this.caseDetail.id
      }
      this.isInfo = false
      this.title = '新增取证'
      this.infoDrawerCtrl = true
    },
    optionConfrim() {
      const url = '/business/evidence/' + this.activeObj.id
      this.$del(url).then(res => {
        this.isSubmit = false
        if (res.code == 0) {
          this.$Message.success('操作成功')
          this.optionCtrl = false
          this.getData()
        } else {
          this.$Message.error(res.message)
        }
      })
    },
    changeCtrl(bool) {
      this.infoDrawerCtrl = false
      if (bool) {
        this.getData()
        this.$emit('reloadList', true)
      }
    },
    // 获取字典数据接口
    async getDictionary() {
      this.evidInvalidList = await this.common.getDictionaryItems(
        'evid_invalid_reason'
      ) // 无效原因
    },
    // 无效确认
    confirmSubmit() {
      this.$refs['formData'].validate(valid => {
        if (valid) {
          const url = '/business/evid/preserver/discard'
          const idData = []
          idData.push(this.invalidId)

          const ajaxData = {
            remark: this.formData.invalidReason,
            ids: idData
          }
          this.isSubmit = true
          this.$post(url, ajaxData)
            .then(res => {
              this.isSubmit = false
              if (res.code === 0) {
                this.$Message.success('操作成功')
                this.confirmStatusStr = false
                this.getData()
              } else {
                this.$Message.error(res.message || '操作失败')
              }
            })
            .catch(() => {
              this.isSubmit = false
              this.$Message.error('操作失败')
            })
        }
      })
    },
    // 重新取证确认
    afreshSubmit() {
      this.$refs['formWebUrlData'].validate(valid => {
        if (valid) {
          const url = '/business/electric/screenshot/again'
          const ajaxData = {
            caseId: this.caseDetail.id,
            webUrl: this.formWebUrlData.webUrl
          }
          this.isSubmit = true
          this.$post(url, ajaxData)
            .then(res => {
              this.isSubmit = false
              if (res.code === 0) {
                this.$Message.success('提交成功')
                this.afreshCtrl = false
                this.getData()
              } else {
                this.$Message.error(res.message || '提交失败')
              }
            })
            .catch(() => {
              this.isSubmit = false
              this.$Message.error('提交失败')
            })
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
@import './../../assets/globalStyle.scss';
.litigant {
  margin: 10px;
  .detail-header {
    background: #fff;
    padding: 5px 0 5px 10px;
    &::before {
      left: 0;
    }
  }
  .add-btn {
    float: right;
  }
  .table-box {
    border: 1px solid #dcdee2;
    border-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/case/caseEvidence.vue